import { datadogRum } from '@datadog/browser-rum';
import React from 'react';
import { useLocation } from 'react-router';
import { useSlate } from '|/context';
import useMfeModule from '|/hooks/use-mfe-module';

declare global {
  interface Window {
    CarvanaChatUiModule: {
      default: any;
    };
  }
}

const DD_ACTION = 'chat-ui-load';

function mfeCacheBuster() {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;
  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
}

const ChatUi = () => {
  const isReady = useMfeModule(
    `${process.env.CHAT_BASE_URL}/build/assets-manifest.json?v=${mfeCacheBuster()}`,
    'main.js',
    'CarvanaChatUiModule',
    DD_ACTION
  );

  const { pathname } = useLocation();
  const { isSlateSkin } = useSlate();

  if (
    !isReady ||
    (pathname.startsWith('/steps/order-placed') && !isSlateSkin) ||
    (pathname.startsWith('/vehicle/') && !isSlateSkin)
  )
    return null;
  datadogRum.addAction(DD_ACTION, { type: 'render' });
  const ChatMfe = window.CarvanaChatUiModule.default;
  return <ChatMfe experience={isSlateSkin ? 'slate' : 'carvana'} />;
};

export default ChatUi;
